var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 91,
    viewBox: "0 0 101 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2299_4405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4288 19.2726C14.4288 8.63478 23.3278 0 34.2426 0C45.1574 0 54.1048 8.63478 54.1048 19.2726C54.1048 29.9104 45.2058 38.5011 34.2426 38.5011C23.2793 38.5011 14.4288 29.8664 14.4288 19.2726Z",
    fill: "#255EAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3203 29.7284C61.3203 21.0466 68.5817 14.0007 77.5291 14.0007C86.4765 14.0007 93.7833 21.0466 93.7833 29.7284C93.7833 38.4101 86.5219 45.5001 77.5291 45.5001C68.5363 45.5001 61.3203 38.4542 61.3203 29.7284Z",
    fill: "#255EAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 78.7292C0 60.3876 15.3431 45.5029 34.2428 45.5029C53.1424 45.5029 68.534 60.3906 68.534 78.7292V79.3342C68.4856 80.5472 67.862 81.6222 66.8026 82.2742C57.2802 87.828 46.1716 91.0029 34.2428 91.0029C22.314 91.0029 11.2538 87.831 1.73136 82.2742C0.671961 81.6222 0.0484296 80.5472 0 79.3342L0 78.7292Z",
    fill: "#255EAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7483 78.7732V79.4281C75.6998 81.0141 75.3154 82.5531 74.6435 83.9071C75.606 83.954 76.5655 84.001 77.5311 84.001C85.2253 84.001 92.4868 82.2741 98.9824 79.1932C100.136 78.6351 100.904 77.4662 101.001 76.2062V75.2723C101.001 62.6725 90.5163 52.4988 77.5311 52.4988C73.9715 52.4988 70.5572 53.2918 67.5273 54.6927C72.673 61.4126 75.7513 69.7184 75.7513 78.7262L75.7483 78.7732Z",
    fill: "#255EAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2299_4405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 91,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendTag);
export default __webpack_public_path__ + "static/media/friend_tag.46fa688d2220211abe8f7a203dcd474c.svg";
export { ForwardRef as ReactComponent };